import React, { useCallback, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { toggleLikedComment, loadDetailPost } from "redux/modules/postSlice";

function LikeToggleComment({ postId, commentId, likeCountFunc }) {
  const dispatch = useDispatch();

  const detailPost = useSelector((state) => state.post.detailPost);
  //const mainPosts = useSelector((state) => state.post.mainPosts);
  //const post = mainPosts.filter((post) => post.boardId === parseInt(postId))[0];
  const comment = detailPost.comments?.filter(
    (comment) => comment.commentId === commentId,
  )[0];

  const replaceNumber = Number(comment?.likeCount.replace(/(^0+)/, ""));
  const [likeCount, setLikeCount] = useState(replaceNumber);
  const [isLiked, setIsLiked] = useState(comment?.isLiked);

  const isMounted = useRef(false);
  useEffect(() => {
    // 이 조건은 컴포넌트가 처음 Mount 되었을 때 아무 동작도 하지 않게 하려고 걸어준 것
    if (!isMounted.current) {
      isMounted.current = true;
    } else {
      likeCountFunc(likeCount);
    }
  }, [likeCount]);

  useEffect(() => {
    setIsLiked(comment?.isLiked);
    setLikeCount(replaceNumber);
    // dispatch(loadDetailPost(detailPost.boardId));
  }, [dispatch, comment?.isLiked, replaceNumber]);

  const onClickToggleLiked = useCallback(() => {
    setIsLiked(true);
    setLikeCount((prev) => prev + 1);

    dispatch(toggleLikedComment(comment.commentId));
  }, [dispatch, setLikeCount, comment]);

  const onClickToggleUnLiked = useCallback(() => {
    setIsLiked(false);
    setLikeCount((prev) => prev - 1);

    dispatch(toggleLikedComment(comment.commentId));
  }, [dispatch, setLikeCount, comment]);

  return (
    <>
      {isLiked ? (
        <img
          src="/img/likedFull.svg"
          alt="좋아요"
          className={`${comment?.isliked}`}
          onClick={onClickToggleUnLiked}
        />
      ) : (
        <img
          src="/img/liked.svg"
          alt="좋아요"
          className={`${comment?.isliked}`}
          onClick={onClickToggleLiked}
        />
      )}
    </>
  );
}

export default LikeToggleComment;
